<template>
  <article>
    <section class="xbed-sub-title">
      <span>自用单列表</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>订单管理</BreadcrumbItem>
        <BreadcrumbItem>自用单列表</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <section style="margin-top:20px"> 
      <Form inline>
        <FormItem>
          <DatePicker v-model="defaultDate" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 220px"></DatePicker>
        </FormItem>
        <FormItem label="审批状态" :label-width="100">
          <Select v-model="status" style="width:100px" @on-change="frontSearch">
            <Option value="-1">全部</Option>
            <Option value="0">待审批</Option>
            <Option value="1">不通过</Option>
            <Option value="2">已审批</Option>
            <Option value="3">免审通过</Option>
            <Option value="4">审核超时</Option>
            <Option value="5">取消申请</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="queryOwnerOrderList">查询</Button>
        </FormItem>
      </Form>
      <br>
      <Table stripe :columns="column" :data="tableData.list"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page show-sizer placement="top" :total="tableData.count" :current="tableData.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
      </div>
    </section>
    <Modal v-model="checkOrder.modal" ref="checkOrderModal" :loading="true" title="审核自用单" @on-ok="subCheckOrder">
        <Form>
          <FormItem label="订单号" :label-width="105">
            <Input :value="checkOrder.order.orderNo" disabled></Input>
          </FormItem>
          <FormItem label="是否审核通过" :label-width="105">
            <Select v-model="checkOrder.order.flag">
              <Option :value="1">通过</Option>
              <Option :value="0">拒接</Option>
            </Select>
          </FormItem>
          <FormItem label="备注" :label-width="105">
            <Input v-model="checkOrder.order.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
          </FormItem>
        </Form>
    </Modal>
  </article>
</template>

<script>
import Moment from "moment";
import Utils from "@/utils";
// import Config from "@/config";
import API from "@/api";

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.queryOwnerOrderList();
  },
  data() {
    return {
      defaultDate: [Moment().subtract(60,'days').format('YYYY-MM-DD'), Moment().format('YYYY-MM-DD')],
      search: {
        "beginDate": Moment().subtract(60,'days').format('YYYY-MM-DD'),
        "endDate": Moment().format('YYYY-MM-DD'),
        "page": 1,
        "rows": "10",
      },
      status: "-1",
      tableData:{
        page:1,
        pageSize:10,
        count:0,
        list:[]
      },
      allData:[],
      allJson:[],
      column: [
        {
          title: "订单号",
          key: "orderNo",
          align: "center",
          width: 210,
        },
        {
          title: "下单时间",
          key: "createdAt",
          align: "center",
          width: 200
        },
        {
          title: "预定人",
          align: "center",
          width: 200,
          render: (h, param) => {
            return h('div',[
              h('p',{},param.row.name),
              h('p',{},param.row.phone)
            ])
          }
        },
        {
          title: "订单渠道",
          align: "center",
          width: 120,
          render: (h, param) => {
            let sourceName = this.codeToName(param.row.source)
            return h('div',{},sourceName);
          }
        },
        {
          title: "入住状态",
          align: "center",
          width: 120,
          render: (h, param) => {
            let checkinName = (
              param.row.checkin == 1 ? '未入住' :
              param.row.checkin == 2 ? '已入住' : '已退房'
            )
            return h('div', {}, checkinName)
          }
        },
        {
          title: "审批状态",
          align: "center",
          width: 120,
          render: (h, param) => {
            let status = (
              param.row.stat == 0 ? '待审批' :
              param.row.stat == 1 ? '不通过' :
              param.row.stat == 2 ? '已审批' :
              param.row.stat == 3 ? '免审通过' :
              param.row.stat == 4 ? '审核超时' :
              param.row.stat == 5 ? '取消申请' : ''
            )
            return h('div', {}, status)
          }
        },
        {
          title: "入住时间",
          key: "beginDate",
          align: "center",
          width: 200
        },
        {
          title: "离开时间",
          key: "endDate",
          align: "center",
          width: 200
        },
        {
          title: "预定房间",
          key: "roomName",
          align: "center",
          width: 200
        },
        {
          title: "房间号",
          key: "roomNo",
          align: "center",
          width: 200
        },
        {
          title: "产权性质",
          key: "direct",
          align: "center",
          width: 200,
          render: (h, param) => {
            let directStr = (
              param.row.direct == 0 ? '租赁房屋' :
              param.row.direct == 5 ? '自有房屋' : '未知'
            )
            return h('div', {}, directStr)
          }
        },
        {
          title: "订单原价",
          key: "price",
          align: "center",
          width: 200,
          render: (h, param) => {
            return h('div', {}, param.row.price/100)
          }
        },
        {
          title: "房间密码",
          key: "openPwd",
          align: "center",
          width: 200,
          render: (h, param) => {
            let show = param.row.openPwd || '密码为空';
            return h('div', [
              h('p', {}, param.row.isShow === 0 ? '******' : show),
              h('A', {
                on: {
                  click: () => {
                    param.row.isShow = ~!param.row.isShow
                  },
                  mouseout: () => {
                    param.row.isShow = 0
                  }
                }
              }, '查看密码')
            ])
          }
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
          width: 200
        },
        {
          title: "申请原因",
          key: "applyReason",
          align: "center",
          width: 200
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          render: (h, param) => {
            if(param.row.stat == 2 || param.row.stat == 3) {
              return h('Button', {
                props: {
                  type: 'primary'
                },
                on: {
                  click: () => {
                    window.location.href = `#/Order/Reserve/newOrderDetailView?orderNo=${param.row.orderNo}`
                  }
                }
              }, '详情') 
            }else if(param.row.stat == 0) {
              return h('Button', {
                props: {
                  type: 'warning'
                },
                on: {
                  click: () => {
                    this.checkOrder.modal = true;
                    this.checkOrder.order.orderNo = param.row.orderNo;
                    this.checkOrder.order.remark = param.row.remark;
                  }
                }
              }, '审核') 
            }
          }
        },
      ],
      checkOrder:{
        modal: false,
        order:{
          orderNo: "",
          flag: 1,
          remark: ""
        }
      }
    }
  },
  methods: {
    changePage(pageIndex) {
      this.tableData.page = pageIndex;
      this.page();
    },
    changePageSize(pageSize) {
      this.tableData.page = 1;
      this.tableData.pageSize = pageSize;
      this.page();
    },
    page() {
      if(this.allData.length==0) {
        this.tableData.list = []
      }
      if(this.allData.length<=this.tableData.pageSize){
        this.tableData.list = this.allData;
      }else{
        this.tableData.list = this.allData.slice(this.tableData.pageSize*(this.tableData.page-1),this.tableData.pageSize*this.tableData.page);
      }
      this.tableData.count = this.allData.length;
    },
    async subCheckOrder() {
      let param = this.checkOrder.order;
      this.$refs.checkOrderModal.buttonLoading = false;
      if(param.remark===""){
        this.$Notice.error({
          title: "备注不能为空",
        });
        return
      }
      let resp = (await API.omsAPI[this.env].php.checkOwnerOrder(
        param,
        this.token
      )).data
      if(resp.retcode != 0) {
        this.$Notice.error({
          title: "审核失败",
          desc: resp.msg
        });
        return;
      }
      this.$Notice.success({
        title: "审核成功"
      });
      this.checkOrder.modal = false;
      this.queryOwnerOrderList();
    },
    async queryOwnerOrderList() {
      this.search.beginDate = Moment(this.defaultDate[0]).format('YYYY-MM-DD');
      this.search.endDate = Moment(this.defaultDate[1]).format('YYYY-MM-DD');
      let resp = (await API.omsAPI[this.env].php.queryOwnerOrderList(
        this.search,
        this.token
      )).data
      if(resp.retcode != 0) {
        this.$Notice.error({
          title: "获取列表失败",
          desc: resp.msg
        });
        return;
      }
      this.$Notice.success({
        title: "查询成功"
      });
      this.allJson = resp.retdata.map(data => {
        data.isShow = 0;
        return data;
      });
      this.allData = this.allJson.slice(0);
      this.page();
    },
    codeToName(code) {
      const nameCode = {'0':'微信端','1':'去哪儿(去呼呼)','2':'IOS端','3':'安卓端','4':'OMS','5':'携程','6':'业主APP','7':'美团','8':'长租','9':'雅尔康','10':'其它','11':'空港','12':'去哪儿','13':'艺龙','14':'小程序','15':'同程旅行','16':'小猪短租','17':'飞猪旅行','18':'途家','19':'公司客（邮件）','20':'airbnb','21':'驴妈妈'}
      return (nameCode[code]||'其他')
    },
    frontSearch() {
      this.tableData.page = 1;
      this.allData = [];
      if(this.status==-1){
        this.allData = this.allJson
      }else{
        for(let i=0;i<this.allJson.length;i++){
          if(this.allJson[i].stat==this.status){
            this.allData.push(this.allJson[i]);
          }
        }
      }
      this.page();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/order/owner-order-list.vue